var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.649 1.064a1 1 0 01.702 0l8 3A1 1 0 0121 5v7c0 3.446-2.282 6.2-4.341 8.003a22.684 22.684 0 01-4.104 2.836 8.28 8.28 0 01-.076.04l-.022.01-.006.004h-.002s-.002.001-.449-.893l-.448.894-.003-.001-.006-.004-.022-.01a8.28 8.28 0 01-.35-.188 22.686 22.686 0 01-3.83-2.689C5.281 18.2 3 15.447 3 12V5a1 1 0 01.649-.936l8-3zM12 22l-.448.894c.282.14.614.141.895 0L12 22zm0-1.137a20.69 20.69 0 003.341-2.365C17.282 16.8 19 14.553 19 12V5.693l-7-2.625-7 2.625V12c0 2.554 1.718 4.8 3.659 6.497A20.692 20.692 0 0012 20.863z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.687 10.155l-5.493 5.07a1.019 1.019 0 01-1.386 0l-2.493-2.3a.917.917 0 01-.004-1.384.988.988 0 01.69-.272 1.019 1.019 0 01.693.275l1.807 1.668 4.807-4.438a1.019 1.019 0 011.607.301.918.918 0 01-.228 1.08z",
    fill: "#000"
  })));
}
export default SvgShieldCheck;